import {FormEvent, useCallback, useMemo, useState} from "react";
import {styled} from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Button from "@memaro/components/Button.tsx";
import Form from "@memaro/components/Form.tsx";
import Alert from "@mui/material/Alert";
import {useAuth} from "../lib/auth.ts";
import {useFormInput} from "@memaro/forms";
import {StepConfirmResetPassword, nameFromError} from "@memaro/auth";
import {useRouter} from "../hooks/useRouter";
import {unauthenticated} from "../hoc/auth.tsx";

const StyledStack = styled(Stack)({
    width: 'fit-content',
    margin: '0 auto'
});

const StyledTextField = styled(TextField)({
    marginTop: 30,
    minWidth: 300,
    fontFamily: "inherit"
})

const ResetPasswordPage = unauthenticated(() => {
    const {gotoLogin, gotoResetPasswordConfirm} = useRouter();
    const {resetPassword} = useAuth();

    const [email, setEmail] = useFormInput()
    const [loading, setLoading] = useState<boolean>(false)
    const [error, setError] = useState<string>("")

    const handleReset = useCallback(async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setLoading(true)
        try {
            const {nextStep} = await resetPassword({
                username: email || "",
            });
            switch (nextStep.resetPasswordStep) {
                case StepConfirmResetPassword:
                    gotoResetPasswordConfirm()
                    break
                default:
                    console.error("Unknown step:", nextStep)
            }
        } catch (e: unknown) {
            setError(nameFromError(e))
        } finally {
            setLoading(false)
        }
    }, [email, gotoResetPasswordConfirm, resetPassword])

    const errorText = useMemo(() => {
        switch (error) {
            case "":
                return ""
            default:
                console.error("Unknown error:", error)
                return "Onbekende fout opgetreden"
        }
    }, [error])

    return (
        <StyledStack>
            <Form onSubmit={handleReset}>
                <h1>Wachtwoord herstellen</h1>
                {errorText ? <Alert severity="error">{errorText}</Alert> : null}
                <StyledTextField type="email" label="Email adres" autoComplete="username" value={email}
                                 onChange={setEmail} autoFocus/>
                <Box sx={{display: "flex", flexDirection: "row-reverse"}}>
                    <Box>
                        <Button sx={{marginTop: "10px"}} onClick={gotoLogin} disabled={loading}>Inloggen</Button>
                        <Button color="primary" type="submit" sx={{marginTop: "10px", marginLeft: "10px"}}
                                loading={loading}>Wachtwoord herstellen</Button>
                    </Box>
                </Box>
            </Form>
        </StyledStack>
    )
})

export default ResetPasswordPage
